import script from "./UnauthorizedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&setup=true&lang=js"

import "./UnauthorizedPage.vue?vue&type=style&index=0&id=e37ab13a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37ab13a"]])

export default __exports__